import { Injectable } from '@angular/core';
import { Zahlung, PaymentStatus, ReconciliationStatus } from './zahlung.service';

@Injectable({
  providedIn: 'root'
})
export class DemoZahlungDataService {

  constructor() { }

  getDemoZahlungen(): Zahlung[] {
    return [
      {
        id: 1,
        bank_transfer_id: "140002506202AEI-58PDN8000323",
        bank_tx_id: "140002506202AEI-58PDN8000323",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 30.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-23",
        buchungs_datum: "2025-06-23",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Ing. Florian Forstenpointner und Wa",
        debtor_iban: "AT592032032102873423",
        debtor_bic: "ASPKAT2LXXX",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017666",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1001,
        aktenzeichen: "2025-001234",
        mandat_betrag_faellig: 30.00,
        mandat_faelligkeitsdatum: "2025-06-20",
        payment_status: PaymentStatus.VOLLSTAENDIG,
        reconciliation_status: ReconciliationStatus.ABGESCHLOSSEN,
        betrag_differenz: 0.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Vollständig bezahlt",
        processing_notes: "Automatisch zugeordnet",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 2,
        bank_transfer_id: "140002506202AEI-58PDN8000324",
        bank_tx_id: "140002506202AEI-58PDN8000324",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 45.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-23",
        buchungs_datum: "2025-06-23",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Maria Mustermann",
        debtor_iban: "AT483200000012345864",
        debtor_bic: "RLNWATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017667",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1002,
        aktenzeichen: "2025-001235",
        mandat_betrag_faellig: 50.00,
        mandat_faelligkeitsdatum: "2025-06-18",
        payment_status: PaymentStatus.UNTERZAHLT,
        reconciliation_status: ReconciliationStatus.GEPRÜFT,
        betrag_differenz: -5.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Unterzahlung - 5€ fehlen",
        processing_notes: "Manuelle Prüfung erforderlich",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 3,
        bank_transfer_id: "140002506202AEI-58PDN8000325",
        bank_tx_id: "140002506202AEI-58PDN8000325",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 75.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-23",
        buchungs_datum: "2025-06-23",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Johann Schmidt",
        debtor_iban: "AT611904300234573201",
        debtor_bic: "RZBAATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017668",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1003,
        aktenzeichen: "2025-001236",
        mandat_betrag_faellig: 60.00,
        mandat_faelligkeitsdatum: "2025-06-15",
        payment_status: PaymentStatus.ÜBERZAHLT,
        reconciliation_status: ReconciliationStatus.PROBLEM,
        betrag_differenz: 15.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Überzahlung - 15€ zu viel",
        processing_notes: "Rücküberweisung prüfen",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 4,
        bank_transfer_id: "140002506202AEI-58PDN8000326",
        bank_tx_id: "140002506202AEI-58PDN8000326",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 25.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-23",
        buchungs_datum: "2025-06-23",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Anna Weber",
        debtor_iban: "AT483200000012345865",
        debtor_bic: "RLNWATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017669",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 0,
        aktenzeichen: "",
        mandat_betrag_faellig: 0,
        mandat_faelligkeitsdatum: "",
        payment_status: PaymentStatus.UNBEKANNT,
        reconciliation_status: ReconciliationStatus.OFFEN,
        betrag_differenz: 0,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Noch nicht zugeordnet",
        processing_notes: "Automatische Zuordnung fehlgeschlagen",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 5,
        bank_transfer_id: "140002506202AEI-58PDN8000327",
        bank_tx_id: "140002506202AEI-58PDN8000327",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 30.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-23",
        buchungs_datum: "2025-06-23",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Peter Müller",
        debtor_iban: "AT611904300234573202",
        debtor_bic: "RZBAATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017670",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1001,
        aktenzeichen: "2025-001234",
        mandat_betrag_faellig: 30.00,
        mandat_faelligkeitsdatum: "2025-06-20",
        payment_status: PaymentStatus.DOPPELT,
        reconciliation_status: ReconciliationStatus.PROBLEM,
        betrag_differenz: 30.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Doppelzahlung erkannt",
        processing_notes: "Rücküberweisung erforderlich",
        is_duplicate: true,
        is_reversed: false
      },
      {
        id: 6,
        bank_transfer_id: "140002506202AEI-58PDN8000328",
        bank_tx_id: "140002506202AEI-58PDN8000328",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 40.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-22",
        buchungs_datum: "2025-06-22",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Franz Huber",
        debtor_iban: "AT483200000012345866",
        debtor_bic: "RLNWATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017671",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1004,
        aktenzeichen: "2025-001237",
        mandat_betrag_faellig: 40.00,
        mandat_faelligkeitsdatum: "2025-06-19",
        payment_status: PaymentStatus.VOLLSTAENDIG,
        reconciliation_status: ReconciliationStatus.ABGESCHLOSSEN,
        betrag_differenz: 0.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Pünktlich bezahlt",
        processing_notes: "Automatisch abgeglichen",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 7,
        bank_transfer_id: "140002506202AEI-58PDN8000329",
        bank_tx_id: "140002506202AEI-58PDN8000329",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 20.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-22",
        buchungs_datum: "2025-06-22",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Lisa Wagner",
        debtor_iban: "AT611904300234573203",
        debtor_bic: "RZBAATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017672",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1005,
        aktenzeichen: "2025-001238",
        mandat_betrag_faellig: 35.00,
        mandat_faelligkeitsdatum: "2025-06-17",
        payment_status: PaymentStatus.TEILWEISE,
        reconciliation_status: ReconciliationStatus.GEPRÜFT,
        betrag_differenz: -15.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Teilzahlung - 15€ noch offen",
        processing_notes: "Nachzahlung erforderlich",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 8,
        bank_transfer_id: "140002506202AEI-58PDN8000330",
        bank_tx_id: "140002506202AEI-58PDN8000330",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 55.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-21",
        buchungs_datum: "2025-06-21",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Thomas Bauer",
        debtor_iban: "AT483200000012345867",
        debtor_bic: "RLNWATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017673",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1006,
        aktenzeichen: "2025-001239",
        mandat_betrag_faellig: 55.00,
        mandat_faelligkeitsdatum: "2025-06-16",
        payment_status: PaymentStatus.VOLLSTAENDIG,
        reconciliation_status: ReconciliationStatus.ABGESCHLOSSEN,
        betrag_differenz: 0.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Vollständig bezahlt",
        processing_notes: "Automatisch abgeglichen",
        is_duplicate: false,
        is_reversed: false
      },
      {
        id: 9,
        bank_transfer_id: "140002506202AEI-58PDN8000331",
        bank_tx_id: "140002506202AEI-58PDN8000331",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 0.00,
        currency: "EUR",
        credit_debit_indicator: "DBIT",
        valuta_datum: "2025-06-21",
        buchungs_datum: "2025-06-21",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Stadtgemeinde Mattighofen",
        debtor_iban: "AT106000000510113853",
        debtor_bic: "BAWAATWWXXX",
        creditor_name: "Max Mustermann",
        creditor_iban: "AT483200000012345868",
        creditor_bic: "RLNWATWW",
        creditor_reference: "523000017674",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1007,
        aktenzeichen: "2025-001240",
        mandat_betrag_faellig: 25.00,
        mandat_faelligkeitsdatum: "2025-06-14",
        payment_status: PaymentStatus.ZURÜCKGEBUCHT,
        reconciliation_status: ReconciliationStatus.ZURÜCKGEBUCHT,
        betrag_differenz: -25.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Rückbuchung wegen unzureichender Deckung",
        processing_notes: "Konto unzureichend gedeckt",
        is_duplicate: false,
        is_reversed: true
      },
      {
        id: 10,
        bank_transfer_id: "140002506202AEI-58PDN8000332",
        bank_tx_id: "140002506202AEI-58PDN8000332",
        bank_msg_id: "6000000510113853000961320250623",
        bank_stmt_id: "6000000510113853000961320250623",
        betrag: 65.00,
        currency: "EUR",
        credit_debit_indicator: "CRDT",
        valuta_datum: "2025-06-20",
        buchungs_datum: "2025-06-20",
        import_datum: "2025-06-23",
        bank_tx_code: "PMNT/RCDT/ESCT",
        bank_tx_code_proprietary: "166",
        bank_tx_code_issuer: "APC",
        debtor_name: "Sabine Fischer",
        debtor_iban: "AT611904300234573204",
        debtor_bic: "RZBAATWW",
        creditor_name: "Stadtgemeinde Mattighofen",
        creditor_iban: "AT106000000510113853",
        creditor_bic: "BAWAATWWXXX",
        creditor_reference: "523000017675",
        creditor_reference_type: "SCOR",
        purpose_code: "UEW",
        mandat_id: 1008,
        aktenzeichen: "2025-001241",
        mandat_betrag_faellig: 50.00,
        mandat_faelligkeitsdatum: "2025-06-13",
        payment_status: PaymentStatus.ÜBERZAHLT,
        reconciliation_status: ReconciliationStatus.GEPRÜFT,
        betrag_differenz: 15.00,
        import_batch_id: 1,
        createdate: "2025-06-23",
        createtime: "12:57:55",
        person: "admin",
        dienstnr_id: 1,
        dienstnr_stvo: 1,
        bemerkungen: "Überzahlung - 15€ zu viel",
        processing_notes: "Rücküberweisung prüfen",
        is_duplicate: false,
        is_reversed: false
      }
    ];
  }
}

